import * as Ariakit from '@ariakit/react'
import React from 'react'

export function TabPanel(props: Ariakit.TabPanelProps) {
  return <Ariakit.TabPanel {...props} />
}
